(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bluejay-pet-mug"] && !Shopify.designMode) return;
  try {
    
(function(){
  const form=document.getElementById('PetPortraitForm');
  if(!form)return;
  const input=form.querySelector('#PetPhoto'),name=form.querySelector('#PetName'),status=form.querySelector('#PetFileStatus'),preview=form.querySelector('.bj-pet__preview'),img=form.querySelector('#PetPhotoPreview'),button=form.querySelector('button[type=submit]');
  let objectUrl;
  function resetPreview(){if(objectUrl)URL.revokeObjectURL(objectUrl);objectUrl=null;preview.hidden=true;img.removeAttribute('src');}
  function validateFile(){
    input.setCustomValidity('');resetPreview();status.textContent='';
    const file=input.files&&input.files[0];if(!file)return;
    if(!['image/jpeg','image/png'].includes(file.type)){input.setCustomValidity('Please choose a JPG or PNG photo.');status.textContent=input.validationMessage;return;}
    if(file.size>10*1024*1024){input.setCustomValidity('Please choose a photo smaller than 10 MB.');status.textContent=input.validationMessage;return;}
    if(file.size===0){input.setCustomValidity('This photo is empty. Please choose another.');status.textContent=input.validationMessage;return;}
    objectUrl=URL.createObjectURL(file);img.src=objectUrl;preview.hidden=false;status.textContent='Photo selected: '+file.name;
    img.onerror=()=>{input.setCustomValidity('We could not read that image. Please choose another JPG or PNG.');status.textContent=input.validationMessage;resetPreview();};
  }
  input.addEventListener('change',validateFile);
  name.addEventListener('input',()=>name.setCustomValidity(name.value.trim()?'':'Please enter your pet’s name.'));
  form.addEventListener('submit',function(event){
    name.value=name.value.trim();name.setCustomValidity(name.value?'':'Please enter your pet’s name.');
    if(!form.checkValidity()){event.preventDefault();form.reportValidity();return;}
    button.disabled=true;button.textContent='Uploading your photo…';
  });
  const initiallyDisabled=button.disabled;
  window.addEventListener('pageshow',()=>{button.disabled=initiallyDisabled;button.textContent=initiallyDisabled?'Currently unavailable':'Add my personalized mug to cart';});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
